import axios from '@_system/axios/axios.js'
export default {
	path: '/BICompetitivegoodstask',
	list(data = {}) {
		return new Promise((resolve,reject) => {
			axios.get(this.path, data, (res) => {
				resolve(res.data)
			},reject)
		})
	},
	save(data = {}) {
		return new Promise((resolve,reject) => {
			axios.post(this.path, data, (res) => {
				resolve(res.data)
			},reject)
		})
	},
	get(id, data = {}) {
		return new Promise((resolve,reject) => {
			axios.get(this.path + '/' + id, data, (res) => {
				resolve(res.data)
			},reject)
		})
	},
	update(id, data = {}) {
		return new Promise((resolve,reject) => {
			axios.put(this.path + '/' + id, data, (res) => {
				resolve(res.data)
			},reject)
		})
	},
	delete(id, data = {}) {
		return new Promise((resolve,reject) => {
			axios.delete(this.path + '/' + id, data, (res) => {
				resolve(res.data)
			},reject)
		})
	},
	addtask(data = {}) {
		return new Promise((resolve,reject) => {
			axios.post(this.path + '/addtask', data, (res) => {
				resolve(res.data)
			},reject)
		})
	},
	listdetail(data = {}) {
		return new Promise((resolve,reject) => {
			axios.get(this.path + '/listdetail', data, (res) => {
				resolve(res.data)
			},reject)
		})
	},
	listsystemtask(data = {}) {
		return new Promise((resolve,reject) => {
			axios.get(this.path + '/listsystemtask', data, (res) => {
				resolve(res.data)
			},reject)
		})
	},
	listsystemtaskshop(data = {}) {
		return new Promise((resolve,reject) => {
			axios.post(this.path + '/listsystemtaskshop', data, (res) => {
				resolve(res.data)
			},reject)
		})
	},
	exportdata(data = {}) {
		return new Promise((resolve,reject) => {
			axios.post(this.path + '/exportdata', data, (res) => {
				resolve(res.data)
			},reject)
		})
	},
	import(data = {}) {
		return new Promise((resolve,reject) => {
			axios.post(this.path + '/import', data, (res) => {
				resolve(res.data)
			},reject)
		})
	},
	export(data = {}) {
		return new Promise((resolve) => {
			axios.post(this.path + '/export', data, (res) => {
				resolve(res.data)
			})
		})
	},
}
